import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Text from '../../elementals/text';
import SubLabel from './subLabel';
import FieldTooltip from './fieldTooltip';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const CheckboxLabel = ({ label, subLabel, compact = false, checkboxType, elmId = 'field', showAnchor = false, helpContent, }) => {
    const options = {
        size: compact ? 'tiny' : 'small',
    };
    if (checkboxType === 'CHECKBOX') {
        options.weight = compact ? 'normal' : 'heavy';
        options.color = compact ? 'grayDark' : 'gray';
    }
    else {
        options.weight = 'normal';
        options.color = 'grayDark';
    }
    return (_jsx(_Fragment, { children: _jsxs("label", { className: cx('checkbox'), children: [typeof label === 'string' ? (_jsx(Text, { className: cx('label', { compact }), ...options, "data-elm-id": `${elmId}_label`, children: label })) : (label), showAnchor && (_jsx("div", { className: cx('tooltip'), children: _jsx(FieldTooltip, { elmId: `${elmId}_tooltip`, helpContent: helpContent, showAnchor: showAnchor, label: label, inverted: true }) })), _jsx(SubLabel, { label: subLabel, compact: compact, className: cx('sub-label'), elmId: elmId })] }) }));
};
CheckboxLabel.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    compact: PropTypes.bool,
    checkboxType: PropTypes.oneOf(['checkbox', 'radio']),
    elmId: PropTypes.string,
    showAnchor: PropTypes.bool,
    helpContent: PropTypes.string,
};
export default CheckboxLabel;
//# sourceMappingURL=checkboxLabel.js.map